import Fire from '../config/Fire';
import {
	USER_RATING_ADD,
	USER_RATING_ADD_SUCCESS,
	USER_RATING_ADD_FAIL,
	USER_RATING_ADD_VOTE,
	USER_RATINGS_FETCH,
	USER_RATINGS_FETCH_SUCCESS,
	USER_RATING_GET_MATCH,
	USER_RATING_GET_MATCH_SUCCESS,
	USER_RATING_UPDATE_REVEAL,
	USER_RATING_UPDATE_REVEAL_SUCCESS,
} from './types';

export const addPlayerRatingByMatch = (mDoc, obj, val, uid) => {
	return dispatch => {
		dispatch({ type: USER_RATING_ADD });
		Fire.firestore()
			.collection('userRatingByMatches')
			.doc(mDoc.toString())
			.collection(obj.playerDoc.toString())
			.doc(uid)
			.set(
				{
					matchDoc: mDoc.toString(),
					playerDoc: obj.playerDoc,
					userRating: val,
				},
				{ merge: true },
			)
			.then(function() {
				return dispatch({ type: USER_RATING_ADD_SUCCESS, payload: obj, id: mDoc, userRating: val });
			})
			.catch(function(_e) {
				console.log('_error', _e);
				dispatch({ type: USER_RATING_ADD_FAIL, error: true, errorText: 'error' });
				setTimeout(function() {
					return dispatch({ type: USER_RATING_ADD_FAIL, error: false, errorText: '' });
				}, 1500);
			});
	};
};

export const updateReveal = (val, matchDoc, id) => {
	return dispatch => {
		dispatch({ type: USER_RATING_UPDATE_REVEAL });
		Fire.firestore()
			.collection('userRatingByUsers')
			.doc(id)
			.collection('matches')
			.doc(matchDoc.toString())
			.set(
				{
					reveal: val,
				},
				{ merge: true },
			)
			.then(function() {
				return dispatch({
					type: USER_RATING_UPDATE_REVEAL_SUCCESS,
					payload: val,
					id: matchDoc,
					uid: id,
				});
			})
			.catch(function(_e) {
				console.log('_error', _e);
				return dispatch({
					type: USER_RATING_UPDATE_REVEAL_SUCCESS,
					payload: val,
					id: matchDoc,
					uid: id,
				});
			});
	};
};

export const fetchMatchByUser = (uid, matchDoc) => {
	return dispatch => {
		dispatch({ type: USER_RATING_GET_MATCH });
		Fire.firestore()
			.collection('userRatingByUsers')
			.doc(uid)
			.collection('matches')
			.doc(matchDoc.toString())
			.get()
			.then(function(doc) {
				let obj = doc.data();
				if (typeof doc.data() === 'undefined') {
					obj = {
						reveal: false,
					};
				}
				return dispatch({
					type: USER_RATING_GET_MATCH_SUCCESS,
					payload: obj,
					id: parseInt(matchDoc, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({
					type: USER_RATING_GET_MATCH_SUCCESS,
					payload: {
						reveal: false,
					},
				});
			});
	};
};

export const fetchPlayerRatingsByUser = (uid, matchDoc) => {
	return dispatch => {
		dispatch({ type: USER_RATINGS_FETCH });
		Fire.firestore()
			.collection('userRatingByUsers')
			.doc(uid)
			.collection('matches')
			.doc(matchDoc.toString())
			.collection('players')
			.get()
			.then(function(querySnapshot) {
				const obj = {};
				querySnapshot.forEach(function(doc) {
					let v = {};
					v = doc.data();
					obj[doc.id] = v;
				});
				return dispatch({
					type: USER_RATINGS_FETCH_SUCCESS,
					payload: obj,
					id: parseInt(matchDoc, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: USER_RATINGS_FETCH_SUCCESS, payload: {} });
			});
	};
};

export const getPlayerRatingByUser = (obj, i, mDoc) => ({
	type: USER_RATING_ADD_VOTE,
	payload: obj,
	id: i,
	matchDoc: parseInt(mDoc, 10),
});

export default { addPlayerRatingByMatch, getPlayerRatingByUser };



// WEBPACK FOOTER //
// ./src/actions/UserRatingActions.js